import { makeStyles, css } from '@conexasaude/conexa-hero'

const useStyles = makeStyles({
  container: css`
    width: 100%;
    margin: 0 auto;
  `,
  row: css`
    display: flex;
    flex-wrap: wrap;
  `,
  columnLogo: css`
    display: flex;
    justify-content: space-between;
    flex: 0 0 100%;
    padding: 0 2px;
  `,
})

export { useStyles }
